// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1_WCf","cls2":"Avatar-cls2_E_C Avatar-cls1_WCf","small":"Avatar-small_kNm"};